import type { CartItem } from '@/store/cartStore'

/**
 * Where a cart line should take you when you click it.
 *
 * Most lines point at their product page. Configured items have no product
 * page — a fototaart is built on its own configurator — so those go back to
 * the configurator carrying the cart key, which restores what the customer
 * had. That is what a shop with a separate build flow normally does: the
 * line links to the thing that made it, not to a catalogue entry that was
 * never there.
 */
export function cartItemHref(item: Pick<CartItem, 'slug' | 'cartKey' | 'productId'>): string {
  if (item.productId === 'FOTOTAART' || item.slug === 'fototaart') {
    return `/genieten-vieren/fototaart?herstel=${encodeURIComponent(item.cartKey)}`
  }
  if (item.slug.startsWith('bundle-')) {
    return `/winkel/pakket/${item.slug.slice('bundle-'.length)}`
  }
  return `/winkel/product/${item.slug}`
}
